import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  key: 1,
  class: "mleft-auto psides-10"
}
const _hoisted_3 = { class: "row mtop-02" }
const _hoisted_4 = { class: "col mtop-06" }
const _hoisted_5 = { class: "menu-col-1" }

import loadingSpinner from "@/views/loadingSpinner.vue";

import { ref, computed } from 'vue'
import gen from '@/functions/general.js';
import officeapi from '@/api/officeapi';
import { useI18n } from 'vue-i18n'

export default /*@__PURE__*/_defineComponent({
  __name: 'newTransaction',
  props: {
  invoice: {
    type: Object,
    required: true,
  },
  allCurrChannels: {
    type: Array,
    required: true,
  },
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const props = __props

const emits = __emit
const currAmount = ref(props.invoice.amount)
const currDate = ref(new Date().toISOString())
const currChannel = ref(null);
const isSubmitting = ref(false)
const selectableChannels = computed(() =>
  props.allCurrChannels.filter(channel => 
    !["Cancelled", "LuPid", "RemainingBalance"].includes(channel.type)
  )
);
const isReady = computed(() => !!currAmount.value && !!currDate.value && !!currChannel.value)

async function createNewTransaction() {
  if (!isReady.value || isSubmitting.value) return;
  isSubmitting.value = true;
  const channel = currChannel.value;
  try {
    const sourceFinancialChannelId = null;
    await officeapi.addTransaction(
      sourceFinancialChannelId,
      channel.id.toString(),
      props.invoice.id,
      currDate.value,
      currAmount.value
    );
    emits('close');
  } finally {
    isSubmitting.value = false;
  }
}

function updateActDate(newIso) {
  currDate.value = newIso
}

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_inputBox = _resolveComponent("inputBox")!
  const _component_inputNewDate = _resolveComponent("inputNewDate")!
  const _component_switchGroup = _resolveComponent("switchGroup")!

  return (_openBlock(), _createElementBlock("div", {
    class: "bg-modal",
    style: {"width":"22rem"},
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_text_item, {
        txt: _unref(t)('accounting.newTransaction'),
        styles: "font-l"
      }, null, 8, ["txt"]),
      (isReady.value && !isSubmitting.value)
        ? (_openBlock(), _createBlock(_component_buttonGroup, {
            key: 0,
            styles: "pad-s",
            class: "border-m mleft-auto psides-06",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (createNewTransaction()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: _unref(t)('action.create'),
                styles: "font-mBold"
              }, null, 8, ["txt"])
            ]),
            _: 1
          }))
        : (isSubmitting.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(loadingSpinner, {
                logo: false,
                style: 'w-1'
              })
            ]))
          : _createCommentVNode("", true)
    ]),
    _createVNode(_component_text_item, {
      txt: _unref(t)('common.amount'),
      class: "mtop-15",
      styles: "font-mBold"
    }, null, 8, ["txt"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_inputBox, { style: {"width":"4rem"} }, {
        default: _withCtx(() => [
          _createVNode(_component_inputLineNew2, {
            ref: "inputRef",
            modelValue: currAmount.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currAmount).value = $event)),
            onKeydown: _unref(gen).onlyNumber,
            onPaste: _unref(gen).onlyNumber
          }, null, 8, ["modelValue", "onKeydown", "onPaste"])
        ]),
        _: 1
      }),
      _createVNode(_component_text_item, {
        txt: " €",
        styles: "main-m",
        class: "mleft-04"
      })
    ]),
    _createVNode(_component_text_item, {
      txt: _unref(t)('common.date'),
      class: "mtop-15",
      styles: "font-mBold"
    }, null, 8, ["txt"]),
    _createVNode(_component_inputNewDate, {
      dateIso: currDate.value,
      calendar: false,
      trash: false,
      onChanged: updateActDate
    }, null, 8, ["dateIso"]),
    _createVNode(_component_text_item, {
      txt: _unref(t)('accounting.paymentType'),
      class: "mtop-20",
      styles: "font-mBold"
    }, null, 8, ["txt"]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectableChannels.value, (channel, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "row"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_switchGroup, {
              active: currChannel.value?.id === channel.id,
              class: "w-full rowcenter",
              style: {"width":"max-content"},
              onClick: ($event: any) => (currChannel.value = channel)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_text_item, {
                  txt: channel.title,
                  styles: "main-m",
                  class: _normalizeClass(currChannel.value?.id === channel.id ? 'txt-white' : '')
                }, null, 8, ["txt", "class"])
              ]),
              _: 2
            }, 1032, ["active", "onClick"])
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})